export default function Playground() {
  return (
    <div>
      <h1>Playground</h1>
    </div>
  );
}
